import { render, staticRenderFns } from "./publish_purchase.vue?vue&type=template&id=738cd777&scoped=true"
import script from "./publish_purchase.vue?vue&type=script&lang=js"
export * from "./publish_purchase.vue?vue&type=script&lang=js"
import style0 from "./publish_purchase.vue?vue&type=style&index=0&id=738cd777&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738cd777",
  null
  
)

export default component.exports